import { gql } from '@apollo/client';

import { ProfessorActivity } from '../../types';
import { professorActivityFragment } from '../fragments';

export interface GetActivityQueryVariables {
  courseId: string;
  activityId: string;
}

export interface GetActivityQueryResult {
  activity: ProfessorActivity;
}

export const getActivityQuery = gql`
  query GetActivityQuery($courseId: String!, $activityId: String!) {
    activity(courseId: $courseId, activityId: $activityId) @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}") {
      ...ProfessorActivity
    }
  }
  ${professorActivityFragment}
`;
